import { createSlice } from '@reduxjs/toolkit';

export const userSIPSlice = createSlice({
    name: 'userSIP',
    initialState: {
        userSIPInfo: null
    },
    reducers: {
        setUserInfoSIP: (state, action) => {
            state.userSIPInfo = action.payload
        }
    }
})
export const { setUserInfoSIP } = userSIPSlice.actions;
export default userSIPSlice.reducer;
